
    import * as React from 'react';

    const Hide12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" style={svgStyle}><path d="M11 5.625H1v.75h10z" /></svg>
        </div>
      );
    };

    Hide12.displayName = 'Hide12';

    export default Hide12;
  